/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import {UltyDateTimePicker} from '@ulty/ulty-ui';
import {useTranslation} from 'react-i18next';
import useMediaQuery from 'beautiful-react-hooks/useMediaQuery';
import { MOBILE_THRESHOLD } from '../../../../constants';
import { addMinutes, endOfDay, isAfter } from 'date-fns'
import { fr } from 'date-fns/locale';

const PosDayOffItem = ({ from, to, readonly, onChange, onError }) => {
    const [t] = useTranslation();
    const isMobile = useMediaQuery(`(max-width: ${MOBILE_THRESHOLD}px)`);

    const handleOnStartDateChange = (date) => {
        if (date && (isAfter(date, to) || !to)) {
            to = endOfDay(date);
        }

        onChange({
            from: date,
            to
        });
    }

    const handleOnEndDateChange = (date) => {
        onChange({
            from,
            to: date
        });
    }

    const handleOnError = (fieldName, reason) => {
        if (!onError) {
            return;
        }
        onError(fieldName, reason);
    }

    return (
        <span
            css={css`
              display: flex;
              column-gap: 1rem;
              ${isMobile ? 'gap: 1rem;' : ''}
              flex-direction: ${isMobile ? 'column' : 'row'};
            `}
        >
            <UltyDateTimePicker
                readonly={readonly}
                label={t('administration.pos_days_off.from')}
                dateTime={from ? new Date(from) : from}
                locale={fr}
                minDateTime={readonly ? undefined : new Date()}
                onChange={handleOnStartDateChange}
                onError={(reason) => handleOnError('from', reason)}
            />

            <UltyDateTimePicker
                readonly={readonly}
                label={t('administration.pos_days_off.to')}
                dateTime={to ? new Date(to) : to}
                locale={fr}
                minDateTime={(readonly || !from) ? undefined : addMinutes(from, 5)}
                onChange={handleOnEndDateChange}
                onError={(reason) => handleOnError('to', reason)}
            />
        </span>
    )
}

export default PosDayOffItem;
